import {
  BetterAuthGetSessionSchema,
  StaffSessionSchema,
  type StaffSessionView,
} from "@bytebite/schemas";
import { apiUrl } from "./api";

export type { StaffSessionView };

export async function fetchStaffSession(): Promise<StaffSessionView | null> {
  const res = await fetch(apiUrl("/auth/get-session"), { credentials: "include" });
  if (!res.ok) {
    return null;
  }
  const payload = BetterAuthGetSessionSchema.parse(await res.json());
  const user = payload?.user;
  const session = payload?.session;
  if (!user || !session) {
    return null;
  }
  return StaffSessionSchema.parse({
    userId: session.userId,
    role: user.role,
    email: user.email,
    name: user.name,
  });
}

export async function signInWithEmail(email: string, password: string): Promise<{ ok: true } | { ok: false; status: number }> {
  const res = await fetch(apiUrl("/auth/sign-in/email"), {
    method: "POST",
    credentials: "include",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) {
    return { ok: false, status: res.status };
  }
  return { ok: true };
}

export async function signOut(): Promise<void> {
  await fetch(apiUrl("/auth/sign-out"), {
    method: "POST",
    credentials: "include",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({}),
  });
}
